//不要格式化
export default {
  home: {
    Login: '登 录', // 登录
    Sign: '注 册', // 注册
    Slogan: '分享每一刻 收获每一刻', //分享每一刻 收获每一刻
    ImmedSign: '立即注册', // 立即注册
    Enter: '进入CloudMaster', // 进入CloudMaster
    Signup: '注册FEEMOO账号', // 注册飞猫盘账号
    Simple: '超简单极速注册', // 超简单极速注册
    Master: '开通CloudMaster', // 开通飞猫达人
    Exclusive: '达人专属标识/权益', //达人专属标识/权益
    ShareFile: '分享文件赚收益', // 分享文件赚收益
    Others: '他人下载/转存即获得收益', // 他人下载/转存即获得收益
    Advantages: '平台优势', // 平台优势
    Multiple: '多种模式灵活玩法多样', //多种模式灵活玩法多样
    CardTitle1: 'FEEMOO返利', // FEEMOO返利
    CardText1: 'FEEMOO是分享型网盘，成为达人后上传文件，生成分享链接供他人下载。', // 飞猫盘是分享型网盘，成为达人后上传文件，生成分享链接供他人下载。
    CardText1_2prefix: '可选择', //可选择
    CardText1_2Blod: '下载量返利模式', //下载量返利模式
    CardText1_2suffix: '，区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益。', //，区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益。
    CardText1_3prefix: '或选择', //或选择
    CardText1_3Blod: '会员返利模式', //会员返利模式
    CardText1_3suffix: '，不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁。', //，不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁。
    CardTitle2: '优惠码返利', // 优惠码返利
    CardText2: '使用专属您的邀请码邀请用户开通FEEMOO会员，您可获得返利收益。', // 使用专属您的邀请码邀请用户开通飞猫盘会员，您可获得返利收益
    CardTitle3: '下线返利', // 下线返利
    CardText3: '好友通过邀请链接注册FEEMOO账号后申请成为CloudMaster，您可获得好友收益的分成返利。', // 好友通过邀请链接注册飞猫盘账号后申请成为飞猫达人，您可获得好友收益的分成返利。
    Income: '真实收益', // 真实收益
    Random: '随机展示上周部分收益提现记录 真实提现看得到', // 随机展示上周部分收益提现记录 真实提现看得到
    Feedback: '真实用户反馈', // 真实用户反馈
    Realization: '上线十年流量变现平台，真实反馈', // 上线十年流量变现平台，真实反馈
    Enjoy: '享受分享的乐趣，轻松赚取属于你的变现收益', // 享受分享的乐趣，轻松赚取属于你的变现收益。
  },
  nav: { //头部模块
    Login: '登 录', //登录
    Sign: '注 册', //注册
    Account: '个人账户', //个人账户
    SignOut: '退出', //退出
  },
  GradeColor: { //等级颜色
    Bronze:'青铜',//青铜
    Silver:'白银',//白银
    Gold:'黄金',//黄金
    Diamond:'钻石',//钻石
    Master:'大师',//大师
    King:'王者',//王者
  },
  IntrDaren: { //未登录展示
    FeeMooMaster: '飞猫达人', //飞猫达人
    TextOne: '开通成为飞猫达人后即可解锁多项推广返利功能！', //开通成为飞猫达人后即可解锁多项推广返利功能！
    OpenVIP: '立即开通', //立即开通
    PlatformPlay: '平台玩法', //平台玩法
    PlateRebate: '飞猫盘返利', //飞猫盘返利
    TextFive: '分享文件给其他用户下载/转存获得收益', //分享文件给其他用户下载/转存获得收益
    PromoCodeRebate: '优惠码返利', //优惠码返利
    TextSix: '用户通过优惠码开通会员获得返利收益', //用户通过优惠码开通会员获得返利收益
    DownlineRebate: '下线返利', //下线返利
    TextSeven: '邀请好友成为飞猫达人获得好友的收益分成', //邀请好友成为飞猫达人获得好友的收益分成
    ActivityRule: '活动规则', //活动规则
    TextTwo: '申请人需完善收款人信息', //申请人需完善收款人信息
    TextThree: '需遵守平台规则', //需遵守平台规则
    TextFour: '《飞猫盘用户服务协议》', //《飞猫盘用户服务协议》
  },
  FmCloud: { //飞猫盘模块
    DownloadRebateMode: '下载量返利模式', //下载量返利模式
    YouHave: '您有', //您有
    FilesUsingMode: '个文件使用该模式', //个文件使用该模式
    MyGrade: '我的等级：', //我的等级：
    TextOne:
      '区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益', //区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益
    DetailedIntroduction: '详细介绍', //详细介绍
    LargeFileIncome: '大文件收益', //大文件收益
    SmallFileIncome: '小文件收益', //小文件收益
    TextTwo: '今日大于100M文件下载量（次）', //今日大于100M文件下载量（次）
    TextThree: '今日小于100M文件下载量（次）', //今日小于100M文件下载量（次）
    WeekAward: '每周飞猫达人奖', //每周飞猫达人奖
    TextFour: '次日上午8点自动兑换到余额', //次日上午8点自动兑换到余额
    NotYetAwarded: '暂未获奖', //暂未获奖
    ReceiveReward: '领取奖励', //领取奖励
    Claimed: '已领取', //已领取
    MemberRebateModel: '会员返利模式', //会员返利模式
    TextFive: '每周三评奖', //每周三评奖
    TextSix:
      '不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁', //不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁
    RebateVIP: '返佣个数', //返佣个数
    CommissionRebate: '返佣金额', //返佣金额
    VIPRebatesToday: '今日返佣个数', //今日返佣个数
    CommissionBackToday: '今日返佣金额', //今日返佣个数
  },
  NavLeft: { //左侧菜单模块
    FEEMOO:'Feemoo',//飞猫盘
    ShortLink:'短链',
    Fm2shortlink: 'Fm2短链', // Fm2短链
    PromotionCode:'优惠码',//优惠码
    DownlineRebate:'下线返利',//下线返利
    HelpCenter:'帮助中心',//帮助中心
    BalanceWithdrawal:'余额提现',//余额提现
    AccountManagement:'账号管理',//账号管理
  },
  Fm2shortlinkbate: {
    Fm2link: 'Fm2短链', //Fm2短链
    dataDetails: '数据明细', //数据明细
    Fm2ShortLink: '什么是Fm2短链？', // 什么是Fm2短链？
    LinkisaFast: 'Fm2短链是一款高效、安全的网址压缩工具，专为中文互联网场景打造。只需一键，就能把冗长的原始链接缩短成「fm2.cc/d/」的极简格式，支持批量新建；支持多种分享模式，与CloudMaster全系产品叠加，一份流量，享多重收益。',
    CreatetoShorten: '新建短链',
    CreatetoShorten2: '输入需要缩短的地址',
    clickyourlin: "分享短链",
    clickyourlin2: "其他人访问你的短链",
    Earnmore: "获得收益",
    Earnmore2: "解锁越多收益越多",
    Fm2Earnings: 'Fm2短链收益',
    Multiplemodels: '多种分享模式灵活选择',
    Directjump1: '免登录无条件解锁：',
    Directjump2: '无需任何操作，用户直接解锁，',
    Directjump3: '元/万次',
    Directjump4: '（最低门槛，适合快速引流）',
    Loginjump1: '登录后无条件解锁：',
    Loginjump2: '用户需先登录账号，无需额外操作，',
    Loginjump3: '元/万次',
    Loginjump4: '（收益提升，需登录授权）',
    Miniadjump1: '去小程序看广告后解锁：',
    Miniadjump2: '用户需扫码在小程序内观看广告，完成后获取链接解锁，',
    Miniadjump3: '元/万次',
    Miniadjump4: '（广告互动，收益翻倍）',
    Feemooadjump1: '去APP看广告后解锁：',
    Feemooadjump2: '用户需通过 Feemoo APP扫码观看广告，完成后获取链接解锁，',
    Feemooadjump3: '元/万次',
    Feemooadjump4: '（最高收益，需通过 Feemoo APP参与）',
    Extrareferralbonus1: '多重收益：',
    Extrareferralbonus2: '其他用户通过你的Fm2短链注册Feemoo账号后，你还将获得引荐计划-Feemoo下线用户奖励',
    Extrareferralbonus3: '（前往了解）',
    DataOverview: '数据概览', //数据概览
    DataOverview2: '每日上午8点更新',
    ViewDetails: '点击查看数据明细', //查看详情
    YesterdayViews: '昨日浏览量',
    YesterdayRedirects: '昨日解锁量',
    YesterdayEarnings: '昨日收益金额',
    Yesterday: '昨日用户通过短链接解锁成功的有效次数',
    RevenueExplanation: '收益说明',
    Shortearnings: '短链收益：',
    payoutdepends: '收益金额取决于该短链设置的收益模式，具体收益金额以页面展示为准。',
    Shortearningtitle: '多重收益：',
    Multiearnings: '其他用户通过你的 Fm2 短链注册 Feemoo账号，即成为你的下线。满足条件即可额外获得三重奖励，与短链收益并行计算，互不冲突。',
    Invalidtraffic: '无效流量：',
    emulators: '任何脚本、模拟器、群控、VPN 代理或其他刷量方式产生的点击，均视为无效，不计收益。',
    Rateadjustments: '调价说明：',
    thirdparty: '若第三方广告平台延迟结算、扣量或拒付，Feemoo 将按同比例下调收益，并在平台公告原因及调整幅度。',
    Violationpolicy: '违规处理：',
    original: '如原始链接被投诉或审核认定为违法、违规、低俗、侵权、欺诈、钓鱼、色情、暴力、赌博、涉政敏感等，Feemoo 将立即锁定该短链并清零收益。如有异议，可在帮助中心申诉。',
    RevenueModel: '分享模式', //分享模式
    UserSteps: '访问用户操作步骤',
    Earningsper: '解锁量收益（元/万次）',
    MultiEarnings: '多重收益',
    NoLoginJump: '免登录无条件解锁',
    Clicklogin: '免登录，点击按钮直接解锁',
    None: '无',
    LoginJumps: '登录后无条件解锁',
    Loginredirect: '先登录，点击按钮直接解锁',
    Registervia: '通过短链注册账号，成为下线用户',
    Miniprogram: '去小程序看广告后解锁',
    WeChatQR: '先登录，微信扫码看广告后自动解锁',
    Appadjump: '去APP看广告后解锁',
    FeemooQR: '先登录，APP扫码看广告后自动解锁',
    Earnings: '收益金额',
    Redirectst: '浏览/解锁量',
    ViewsViews: '浏览量',
    ViewsViewss: '解锁量',
    Directjump11: '免登录无条件解锁',
    Loginjump11: '登录后无条件解锁',
    Miniadjump11: '去小程序看广告后解锁',
    Feemooadjump11: '去APP看广告后解锁',
  },
  MemberRebate: { //优惠码模块
    RebateCode:'返利优惠码',//返利优惠码
    IncomeData:'收益数据',//收益数据
    //返利优惠码模块
    rebateDisCode:{
      YourCurrentLevel:'您当前等级：',//您当前等级：
      Levels:'等级介绍',//等级介绍
      CouponCodeDiscount:'优惠码折扣',//优惠码折扣
      RebateRatio:'返利比例',//返利比例
      MyPromoCode:'我的优惠码：',//我的优惠码：
      MyCode:'我的优惠码',//我的优惠码
      Copy:'复制',//复制
      CopyCode: '复制优惠码', //复制优惠码
      MemberRebateIncome:'会员返利收益',//会员返利收益
    },
    //收益数据模块
    incomeData:{
      MemberRebateProgram:'会员返利计划',//会员返利计划
      TextOne:'用户通过优惠码开通会员，您可获得收益',//用户通过优惠码开通会员，您可获得收益
      Levels:'等级介绍',//等级介绍
      MyGrade: '我的等级：', //我的等级：
      MemberRebateIncome:'会员返利收益',//会员返利收益
      OpenMembership:'开通会员人数',//开通会员人数
      UserNickname:'用户昵称',//用户昵称
      OpeningTime:'开通时间',//开通时间
      RebateAmount:'返利金额',//返利金额
    },
  },
  OfflineRebate: { //下线返利模块
    InviteRegisterLink:'邀请注册链接',//邀请注册链接
    IncomeData:'收益数据',//收益数据
    yuan:'元',//元
    InvitationLink:{ //邀请注册链接
      Text:'玩法说明',//玩法说明
      TextOne:'好友通过邀请链接注册飞猫盘账号后申请成为飞猫达人，您可获得好友收益的高额返利。',//好友通过邀请链接注册飞猫盘账号后申请成为飞猫达人，您可获得好友收益的高额返利。
      TextTwo:'需通过你的邀请链接注册飞猫盘账号成功，并且申请开通成为飞猫达人。',//需通过你的邀请链接注册飞猫盘账号成功，并且申请开通成为飞猫达人
      TextThree:'好友成为达人后获得飞猫盘返利收益，你就能获得好友的收益分成。',//好友成为达人后获得飞猫盘返利收益，你就能获得好友的收益分成。
      TextFour:'邀请越多好友成为达人，获得更多收益分成，上不封顶。',//邀请越多好友成为达人，获得更多收益分成，上不封顶
      InviteNow:'立即邀请',//立即邀请
      CopyInvitationLink:'复制邀请链接',//复制邀请链接
      SavePicture:'保存图片',//保存图片
      DownLineIncome:'下线收益',//下线收益
      Save:'保存',//保存
      TodayEarnings:'今日收益',//今日收益
      Yesterday:'昨日',//昨日
      CurrentEarnings:'本月收益',//本月收益
      SeeMore:'查看更多',//查看更多
      InvitationRecord:'邀请记录',//邀请记录
      UserNickname:'用户昵称',//用户昵称
      TextFive:'是否开通CloudMaster',//是否开通飞猫达人
      InvitationTime:'邀请注册时间',//邀请注册时间
      TextSix:'获得99元下线返利',//获得99元下线返利
      HaveOpened:'已开通',//已开通
      HaveNotOpened:'未开通',//未开通
    },
    offIncomeData:{ //收益数据
      TodayEarnings:'今日收益',//今日收益
      YesterdayEarnings:'昨日收益',//昨日收益
      CurrentEarnings:'本月收益',//本月收益
      TextOne:'收益记录',//收益记录
      UserNickname:'用户昵称',//用户昵称
      TextTwo:'返利金额（元）',//返利金额（元）
      TextThree:'为什么我还没有获得下线返利收益：',//为什么我还没有获得下线返利收益：
      TextFour:'1、检查好友状态：请查看邀请记录，确认好友是否已成为飞猫达人。',//1、检查好友状态：请查看邀请记录，确认好友是否已成为飞猫达人。
      TextFive:'2、等待收益结算：若好友已是飞猫达人，需等待他们产生收益并在次日结算后，您才能获得返利收益分成。',//2、等待收益结算：若好友已是飞猫达人，需等待他们产生收益并在次日结算后，您才能获得返利收益分成。
    },
  },
  help: { //帮助中心模块
    FEEMOO:'Feemoo',//飞猫盘
    CouponCode:'优惠码',//优惠码
    DownlineRebate:'下线返利',//下线返利
    ComplaintBox:'意见箱',//意见箱
    ContactCustomer:'联系客服',//联系客服
    fmp:{ //飞猫盘
      MembershipRebateModel: '会员返利模式', // 会员返利模式
      DownloadVolumeRebateModel: '下载量返利模式', // 下载量返利模式
      DownloadUserExperience: '下载用户体验:', // 下载用户体验
      NonMembers: '非会员：', // 非会员
      FirstDownloa: '每次首次下载免福利点（正常用户）、后续下载需要福利点，无福利点时也可以使用下载券或者看视频下载方式进行下载，下载速度较慢、文件不过期。', // 每次首次下载免福利点（正常用户）、后续下载需要福利点，无福利点时也可以使用下载券或者看视频下载方式进行下载，下载速度较慢、文件不过期。
      FirstDownloa2: '下载不需要福利点、无下载次数限制、下载速度较慢、文件不过期、下载页面简洁。', // 下载不需要福利点、无下载次数限制、下载速度较慢、文件不过期、下载页面简洁。
      Members: '会员：',
      Downloadsuse: '下载消耗会员下载额度，下载速度极快。',
      Downloadsuse2: '下载不消耗会员下载额度、下载速度极快。',
      EarningsRules: '收益规则：',
      Filesreategorized: '根据文件是否大于等于100M区分文件属性为大文件或小文件，根据昨日下载量评定等级和单价，按下载量返利，万次下载最高1888元，并且每周三、周四双倍享受收益（仅限下载量返利模式产生的收益）。', // 根据文件是否大于等于100M区分文件属性为大文件或小文件，根据昨日下载量评定等级和单价，按下载量返利，万次下载最高1888元，并且每周三、周四双倍享受收益（仅限下载量返利模式产生的收益）。
      Filesreategorized2: "按用户支付金额的45%返利。",
      Filesreategorized3: "按用户支付金额的",
      Filesreategorized4: "（单笔最高100元）返利。",
      EarningsProfile:'收益简介',//收益简介
      TextOne:'分享文件给其他用户下载/转存你就能获得收益，每日所得收益次日凌晨自动结算。',//分享文件给其他用户下载/转存你就能获得收益，每日所得收益次日凌晨自动结算。
      TextTwo:'下载量返利模式：',//下载量返利模式：
      TextThree:'区分大小文件按',//区分大小文件按
      TextFour:'下载量返利',//下载量返利
      TextFive:'，区分等级万次下载最高',//，区分等级万次下载最高
      TextSix:'1888元',//1888元
      TextSeven:'，每周三、周四',//，每周三、周四
      TextEight:'双倍',//双倍
      TextNine:'收益。',//收益。
      TextTen:'会员返利模式：',//会员返利模式：
      TextEleven:'不按下载次数计费，只根据下载用户开通会员进行按',//不按下载次数计费，只根据下载用户开通会员进行按
      TextTwelve:'比例分成',//比例分成
      TextThirteen:'，文件',//，文件
      TextFourteen:'不过期',//不过期
      TextFifteen:'，页面更简洁。',//，页面更简洁，适合
      TextSixteen:'大文件',//大文件
      TextSeventeen:'分享。',//分享。
      IncomeModelComparison:'收益模式对比',//收益模式对比
      Equity:'权益',//权益
      DownloadsRebateModel:'下载量返利模式',//下载量返利模式
      VIPRebateModel:'会员返利模式',//会员返利模式
      MoreModes:'更多模式即将上线',//更多模式即将上线
      DownloadRebateRules:'下载量返利模式规则',//下载量返利模式规则
      RebateMechanism:'1、返利机制：',//1、返利机制：
      TextEighteen:'按当日达人等级与当日所产生的下载量，在次日凌晨自动结算返利收益金额。',//按当日达人等级与当日所产生的下载量，在次日凌晨自动结算返利收益金额。
      levelRules:'2、等级规则：',//2、等级规则：
      TextNineteen:'根据昨日所产生的下载量来确定该模式下的达人返利等级，例如昨日下载量达到302，则今日达人等级为黄金。',//根据昨日所产生的下载量来确定该模式下的达人返利等级，例如昨日下载量达到302，则今日达人等级为黄金。
      doubleRevenue:'3、双倍收益：',//3、双倍收益：
      TextTwenty:'每周三、周四可获得双倍的下载量返利收益。',//每周三、周四可获得双倍的下载量返利收益。
      MemberRebateModel:'会员返利模式规则',//会员返利模式规则
      RebateMechanismTwo:'1、返利机制：',//1、返利机制：
      twentyOne:'选择会员返利模式后，其他用户通过你分享的下载链接访问，在下载或转存文件后，将与你建立24小时的绑定关系。在绑定期内，若用户在网页端或APP端上开通会员，你将获得其会员费用的',
      twentyTwo:'（每笔交易最高100元人民币）作为返利。',//作为返利。
      multiplePurchaseRebate:'2、多次购买返利：',//2、多次购买返利：
      twentyThree:'在24小时绑定期内，用户若多次开通会员，每次开通会员金额的',//在24小时绑定期内，用户若多次开通会员，每次开通会员金额的
      twentyFour:'均将作为您的返利。',//均将作为您的返利。
      BindingRestrictions:'3、绑定关系限制：',//3、绑定关系限制：
      twentyFive:'一旦用户与您建立了绑定关系，他们在24小时内将无法与其他达人建立新的绑定关系。',//一旦用户与您建立了绑定关系，他们在24小时内将无法与其他达人建立新的绑定关系。
      discountCode:'4、优惠码返利限制：',//4、优惠码返利限制：
      twentySix:'当用户使用优惠码开通会员，您只能获得优惠码返利，会员返利收益将无法叠加。',//当用户使用优惠码开通会员，您只能获得优惠码返利，会员返利收益将无法叠加。
    },
    discountCode:{ //优惠码
      TextOne:'什么是优惠码？',//什么是优惠码？
      TextTwo:'好友通过您的优惠码开通会员享折扣，同时您可获得高额返利；达人等级越高，优惠码折扣越大。',//好友通过您的优惠码开通会员享折扣，同时您可获得高额返利；达人等级越高，优惠码折扣越大。
      MasterRating:'达人等级',//达人等级
    },
    rebate:{ //下线返利
      TextOne:'什么是下线返利？',//什么是下线返利？
      TextTwo:'用户A邀请用户B注册，则用户B成为用户A的下线：',//用户A邀请用户B注册，则用户B成为用户A的下线：
      TextThree:'平台按用户B在飞猫盘推广活动中获得收益的15%额外给用户A奖励，持续有效。',//平台按用户B在飞猫盘推广活动中获得收益的15%额外给用户A奖励，持续有效。
      MasterRating:'达人等级',//达人等级
    },
    contactCust:{ //联系客服
      HotIssue:'热门问题',//热门问题
      View:'查看',//查看
      AdditionalHelp:'其他帮助',//其他帮助
      SubmitATicket:'提交工单',//提交工单
      SubmitNow:'立即提交',//立即提交
      FeedbackHistory:'反馈历史',//反馈历史
      ViewHistory:'进入查看',//进入查看
      TextOne:'联系客服',//联系客服
      TextTwo:'立即在线沟通',//立即在线沟通
      TextThree:'没找到问题，点此提交问题',//没找到问题，点此提交问题
      LatestAnnouncements:'最新公告',//最新公告
      FAQ:'常见问题',//常见问题
      Back:'返回',//返回
      LoginRegister:'登录注册',//登录注册
      WithdrawEarnings:'收益提现',//收益提现
    },
  },
  IncomeReflect: { //余额提现模块
    BalanceWithdrawal:'余额提现',//余额提现
    WithdrawalRecord:'提现记录',//提现记录
    PayeeManagement:'收款人管理',//收款人管理
    tabZero:{ //余额提现
      withdrawableAmount:'可提现金额',//可提现金额
      Important: '重要提示：近期支付宝官方的收款风控规则调整导致部分用戶无法正常收款，平台建议新增银行卡收款人，暂时以銀行卡方式提现。',
      yuan:'元',//元
      Payee:'收款人',//收款人
      NewPayee:'新增收款人',//新增收款人
      PleaseSelect:'请选择',//请选择
      CashWithdrawal:'提现金额',//提现金额
      TextOne:'请输入提现金额',//请输入提现金额
      TextTwo:'每笔提现最低30元',//每笔提现最低30元
      phoneNumber:'手机号',//手机号
      PleasePhone:'请输入手机号',//请输入手机号
      VerificationCode:'验证码',//验证码
      TextThree:'请输入手机号验证码',//请输入手机号验证码
      TextFour:'获取验证码',//获取验证码
      Sent:'已发送',//已发送
      WithdrawCashNow:'立即提现',//立即提现
      TextFive:'您尚未进行手机绑定，提现成功后将默认绑定此手机号',//您尚未进行手机绑定，提现成功后将默认绑定此手机号
      SelectAPayee:'请选择收款人',//请选择收款人
      TextSix:'请输入提现金额',//请输入提现金额(每笔提现最低
      yuana:'元)',
      WithdrawalRules:'提现规则介绍',//提现规则介绍
      TextSeven:'1.提现次数：账号可添加多位收款人，每位收款人在30天内最多提现9次。',//1.提现次数：账号可添加多个收款人，每个收款人每 30 天内最多可提现 9 次。
      TextEight:'2.累计额度：每位收款人每年累计提现上限为人民币600,000元。',//2.累计限额：每个收款人每年累计提现金额最多为 60 万元人民币。
      TextNine:'3.单笔额度：单笔独立限额为人民币200–50,000元。',//3.单笔限额：单笔提现金额上限为 5 万元人民币。
      TextTen:'4.最低提现金额：每笔提现金额不得低于 200 元人民币。',//4.最低提现金额：每笔提现金额不得低于 200 元人民币。
      tooltipSeven:'提现金额限制：',
      tooltipEight:'单笔独立限额为人民币200–50,000元。',
      tooltipNine:'中国内地银行卡单笔独立限额为人民币800–25,000元。',
    },
    tabOne:{ //提现记录
      OrderNumber:'订单号',//订单号
      Amount:'金额',//金额
      Status:'状态',//状态
      Time:'时间',//时间
      TextOne:'提现记录为空~',//提现记录为空~
      awaitingProcessing:'待处理',//待处理
      Successful:'成功',//成功
      Fail :'失败',//失败
      ViewCauses :'查看原因',//查看原因
    },
    tabTwo:{ //收款人管理
      NewPayee:'新增收款人',//新增收款人
      UserNickname:'用户昵称',//用户昵称
      AlipayAccount:'支付宝账号',//支付宝账号
      IdNumber:'身份证号',//身份证号
      TextOne:'当月提现额度',//当月提现额度
      Controls:'操作',//操作
      Editor:'编辑',//编辑
      Delete:'删除',//删除
      NoRecord:'暂无记录',//暂无记录
      PaymentMethod:'收款方式',//收款方式
      PaymentAccount:'收款账号',//收款账号
      AnnualWithdrawalLimit:'年度可提现额度',//年度可提现额度
      MonthlyWithdrawalCount:'近30天内已提现次数',//近30天内已提现次数
    }
  },
  Account: { //账号管理模块
    TextOne:'咨询客服了解更多',//咨询客服了解更多
    ContactCellPhone:'联系手机',//联系手机
    ContactEmail:'联系邮箱',//联系邮箱
    FEEMOOCertification:'飞猫达人认证',//飞猫达人认证
    FEEMOOCertificationTwo:'CloudMaster',//CloudMaster
    SubscriptionNumberOpening:'订阅号开通',//订阅号开通
    CertifiedFEEMOOMaster:'已认证飞猫达人',//已认证飞猫达人
    CertifiedFEEMOOMasterTwo:'未认证CloudMaster',//未认证CloudMaster
    TextTwo:'已开通订阅号',//已开通订阅号
    TextThree:'修改绑定手机',//修改绑定手机
    TextFour:'修改绑定邮箱',//修改绑定邮箱
    Accredited:'已认证',//已认证
    TextFive:'进入订阅号',//进入订阅号
    BoundPhone:'绑定手机',//绑定手机
    BoundMailbox:'绑定邮箱',//绑定邮箱
    UncertifiedFEEMOO:'未认证飞猫达人',//未认证飞猫达人
    GetCertified:'去认证',//去认证
    SubscriptionNotAvailable:'未开通订阅号',//未开通订阅号
    GoAndActivate:'去开通',//去开通
    NotActivated:'未开通',//未开通
    ActivateNow:'立即开通',//立即开通
    ActivatedNEW:'已开通',//已开通
  },
  LevelTable: { //等级表格
    ClassInterest:'等级权益',//等级权益
    DownloadsYesterday:'昨日下载量',//昨日下载量
    TextOne:'大文件返利（元/万次）',//大文件返利（元/万次）
    TextTwo:'小文件返利（元/万次）',//小文件返利（元/万次）
    CouponCodeDiscount:'优惠码折扣',//优惠码折扣
    PromoCodeRevenue:'优惠码收益',//优惠码收益
  },
  TablePublic: { //表格组件模块
    UserNickname:'用户昵称',//用户昵称
    OpeningTime:'开通时间',//开通时间
    RebateAmount:'返利金额',//返利金额
    NoRecord:'暂无记录',//暂无记录
    QRCode:'二维码',//二维码
    InvitationCode:'邀请码',//邀请码
    InvitationLink:'邀请链接',//邀请链接
  },
  MemRbCom: { //会员返利收益组件
    Today:'今日',//今日
    Yesterday:'昨日',//昨日
    CurrentEarnings:'本月收益',//本月收益
    yuan:'元',//元
  },
  userNew: { // 信息悬浮框模块
    All: '全部', // 全部
    SystemNotification: '系统通知', // 系统通知
    OfficialNews: '官方消息', // 官方消息
    ReadAll: '全部已读', // 全部已读
    Nonews: '暂无消息', // 暂无消息
  },
  exPand:{
    referralProgram:'引荐计划',//引荐计划
    exTextOne:'什么是引荐计划？',//什么是引荐计划？
    exTextTwo:'引荐用户注册Feemoo账号成为你的下线可同时获得三重奖励：下载券、会员时长奖励或开通会员收益分成、下线返利收益。',//引荐用户注册Feemoo账号成为你的下线可同时获得三重奖励：下载券、会员时长奖励或开通会员收益分成、下线返利收益。
    InvitationMethods:'邀请方式',//邀请方式
    exTextThree:'每个邀请链接都能注册Feemoo账号，拉新更轻松。换个宣传方式，吸引更多人成为你的下线！',//每个邀请链接都能注册Feemoo账号，拉新更轻松。换个宣传方式，吸引更多人成为你的下线！
    exTextFour:'介绍Feemoo功能，吸引下线开通会员',//介绍Feemoo功能，吸引下线开通会员
    CopyInviteLink:'复制邀请链接',//复制邀请链接
    exTextFive:'介绍CloudMaster多种返利收益，吸引下线开通CloudMaster',//介绍CloudMaster多种返利收益，吸引下线开通CloudMaster
    exTextSix:'奖励一：邀请注册奖励',//奖励一：邀请注册奖励
    InviteHistory:'邀请记录',//邀请记录
    NumberofInvitedReferrals:'已邀请下线人数',//已邀请下线人数
    ValidInvites:'有效邀请人数',//有效邀请人数
    TotalRewards:'累计奖励',//累计奖励
    users:'人',//人
    Sheet:'张',//张
    Days:'天',//天
    money:'元',//元
    ci:'次',//次
    exTextSeven:'·注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后视为有效邀请',//·注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后视为有效邀请
    exTextEight:'·同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo官方会过滤异常数据。',//·同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo官方会过滤异常数据。
    exTextNine:'每次有效邀请奖励5张下载券，最多累计获得50位新用户邀请奖励。',//每次有效邀请奖励5张下载券，最多累计获得50位新用户邀请奖励。
    exTextTen:'获得50位新用户邀请奖励。',//获得50位新用户邀请奖励。
    exTextEleven:'奖励二：下线开通会员',//奖励二：下线开通会员
    CurrentRewards:'当前奖励方式：',//当前奖励方式：
    Membershipduration:'会员时长奖励',//会员时长奖励
    ActivationAmount:'开通金额奖励',//开通金额奖励
    PendingRewards:'待处理奖励',//待处理奖励
    ReceivedRewards:'已到账奖励',//已到账奖励
    TotalRewards:'累计奖励',//累计奖励
    EarningsRecords:'收益记录',//收益记录
    TodayEarnings:"今日收益",//今日收益
    YesterdayEarnings:"昨日收益",//昨日收益
    TotalEarnings:'累计收益',//累计收益
    exTextTwelve:'奖励三：下线返利',//奖励三：下线返利
    Rules:'规则说明',//规则说明
    RewardRules:'奖励规则',//奖励规则
    RewardOne:'奖励一：',//奖励一：
    exTextThirteen:'通过您链接邀请的第一位新用户注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，首次邀请您可获得3天体验会员时长，后续您每邀请1位可获得1天体验会员时长。',//通过您链接邀请的第一位新用户注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，首次邀请您可获得3天体验会员时长，后续您每邀请1位可获得1天体验会员时长。
    RewardTwo:'奖励二：',//奖励二：
    exTextFourteen:'通过您链接邀请的新用户注册Feemoo账号登录后，将成为你的下线，其在3个月（90天）内每次成功购买Feemoo会员，您可选择按会员时长奖励或实付金额的20%获得奖励。',//通过您链接邀请的新用户注册Feemoo账号登录后，将成为你的下线，其在3个月（90天）内每次成功购买Feemoo会员，您可选择按会员时长奖励或实付金额的20%获得奖励。
    exTextFifteen:'例如：若您的下线3个月内购买4次月度会员，您将获赠24天月度会员时长或24元返利收益；若其购买不限时长会员，您将获赠77.6天体验会员时长或77.6元返利收益。',//例如：若您的下线3个月内购买4次月度会员，您将获赠24天月度会员时长或24元返利收益；若其购买不限时长会员，您将获赠77.6天体验会员时长或77.6元返利收益。
    RewardThree:'奖励三：',//奖励三：
    exTextSixteen:'通过您链接邀请的新用户注册Feemoo账号登录后，成功开通CloudMaster并完成Feemoo返利收益结算，您即可获得该下线用户收益的15%分成。',//通过您链接邀请的新用户注册Feemoo账号登录后，成功开通CloudMaster并完成Feemoo返利收益结算，您即可获得该下线用户收益的15%分成。
    ExpandDownstreamMode:'扩充下线模式：',//扩充下线模式：
    exTextSeventeen:'除专属邀请链接外，您也可通过扩充下线模式的文件链接分享给其他人注册来扩充更多下线。',//除专属邀请链接外，您也可通过扩充下线模式的文件链接分享给其他人注册来扩充更多下线。
    AssessmentCriteria:'判定细则',//判定细则
    exTextEighteen:'下线用户购买会员的开通奖励会在 30 分钟内发放到待处理收',//下线用户购买会员的开通奖励会在 30 分钟内发放到待处理收
    exTextNineteen:'益，符合条件的分成奖励需等待 7 天后才可到账提现，',//益，符合条件的分成奖励需等待7天后才可到账提现，
    exTextTwenty:'特殊情况可能会延迟。',//特殊情况可能会延迟。
    exTextTwentyOne:'新用户需通过您的专属邀请链接注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，才视为有效邀请。',//新用户需通过您的专属邀请链接注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，才视为有效邀请。
    exTextTwentyTwo:'您作为上线用户，邀请下线用户的新用户注册奖励，仅限前50位有效邀请。超出后，上线用户不再获此奖励，但购买会员的分成奖励与下线返利无次数、人数限制，上不封顶。',//您作为上线用户，邀请下线用户的新用户注册奖励，仅限前50位有效邀请。超出后，上线用户不再获此奖励，但购买会员的分成奖励与下线返利无次数、人数限制，上不封顶。
    exTextTwentyThree:'奖励一的统计数据起始时间为2025年5月30日，您在该时间之前邀请的新用户无法获得该奖励。',//奖励一的统计数据起始时间为2025年5月30日，您在该时间之前邀请的新用户无法获得该奖励。
    exTextTwentyFour:'下线用户自注册起3个月（90天）内，通过官方渠道会员订阅或APP内购开通会员，视为成功购买会员。而通过免费兑换、奖励等获得的免费会员资格，不视为购买会员。',//下线用户自注册起3个月（90天）内，通过官方渠道会员订阅或APP内购开通会员，视为成功购买会员。而通过免费兑换、奖励等获得的免费会员资格，不视为购买会员。
    exTextTwentyFive:'通过您的邀请链接注册账号的下线用户，如果用户使用优惠码开通会员，您只能获得优惠码返利，奖励二将无法叠加。',//通过您的邀请链接注册账号的下线用户，如果用户使用优惠码开通会员，您只能获得优惠码返利，奖励二将无法叠加。
    exTextTwentySix:'通过您的邀请链接注册账号的下线用户，如果下载会员返利模式文件并在24小时内开通会员，你只能获得会员返利模式收益，奖励二无法叠加。',//通过您的邀请链接注册账号的下线用户，如果下载会员返利模式文件并在24小时内开通会员，你只能获得会员返利模式收益，奖励二无法叠加。。
    exTextTwentySeven:'奖励二的统计数据起始时间为2025年5月30日，近3个月（90天）内您邀请的下线用户在2025年5月30日后开通会员，您仍可获得该奖励。',//奖励二的统计数据起始时间为2025年5月30日，近3个月（90天）内您邀请的下线用户在2025年5月30日后开通会员，您仍可获得该奖励。
    exTextTwentyEight:'您在2025年5月30日之前邀请的下线用户仍可获得该奖励。',//您在2025年5月30日之前邀请的下线用户仍可获得该奖励。
    OtherNotes:'其他说明',//其他说明
    exTextTwentyNine:'邀请奖励与下线返利将在48小时内发放至当前用户账号；下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。',//邀请奖励与下线返利将在48小时内发放至当前用户账号；下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。
    exTextThirty:'通过奖励所获得的体验会员时长，将自动发放到当前用户账号，具体发放时间请查看系统通知。',//通过奖励所获得的体验会员时长，将自动发放到当前用户账号，具体发放时间请查看系统通知。
    exTextThirtyOne:'通过奖励所获得的体验会员时长，无法通过补差价升级为不限时长会员。',//通过奖励所获得的体验会员时长，无法通过补差价升级为不限时长会员。
    exTextThirtyTwo:'同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo官方会过滤异常数据。',//同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo官方会过滤异常数据。
    exTextThirtyThree:'对于违规行为（包括但不限于恶意刷量、违规折现、模拟用户行为等），Feemoo官方有权取消参与者的活动资格，并采取收回奖励、封禁账号等措施。如有异议，可通过帮助中心提交问题申诉。',//对于违规行为（包括但不限于恶意刷量、违规折现、模拟用户行为等），Feemoo官方有权取消参与者的活动资格，并采取收回奖励、封禁账号等措施。如有异议，可通过帮助中心提交问题申诉。
    exTextThirtyFour:'为更准确识别恶意刷量，部分低版本 APP 注册用户将无法获得引荐计划活动奖励。',//为更准确识别恶意刷量，部分低版本 APP 注册用户将无法获得引荐计划活动奖励。
    exTextThirtyFive:'如果我们已向您发放了收益，但您或您的下线用户违反了我们的用户协议或规则，则我们会保留从应向您发放的未来收益中扣除已支付收益的权利。',//如果我们已向您发放了收益，但您或您的下线用户违反了我们的用户协议或规则，则我们会保留从应向您发放的未来收益中扣除已支付收益的权利。
    exTextThirtySix:'此活动仅限Feemoo用户参加，最终解释权归Feemoo官方所有。',//此活动仅限Feemoo用户参加，最终解释权归Feemoo官方所有。
    HeadTo:'前往',//前往
    exTextThirtySeven:'创建分享选择下载量返利模式',//创建分享选择下载量返利模式
    exTextThirtyEight:'其他用户通过分享链接下载文件成功',//其他用户通过分享链接
    exTextThirtyNine:'区分大小文件按下载量返利',//下载文件成功
    exTextForty:'每周三、周四双倍收益！',//每周三、周四双倍收益！
    exTextFortyOne:'其他用户通过分享链接下载文件成功后建立绑定关系',//其他用户通过分享链接下载文件成功后建立绑定关系
    exTextFortyTwo:'已有绑定关系的用户24小时内开通会员',//已有绑定关系的用户24小时内开通会员
    exTextFortyThree:'你获得绑定关系用户开通会员的分成收益',//你获得绑定关系用户
    ExpandReferralsMode:'扩充下线模式',//扩充下线模式
    exTextFortyFour:'通过分享链接注册成为新用户后建立下线关系',//通过分享链接注册成为新用户后建立下线关系
    exTextFortyFive:'更多的下线让你在',//更多的下线让你
    exTextFortySix:'引荐计划',//引荐计划
    exTextFortySeven:'中获得更多收益',//中获得更多收益
    exTextFortyEight:'今日新增下线人数',//今日新增下线人数
    exTextFortyNine:'累计下线人数',//累计下线人数
    exTextFifty:'创建分享选择会员返利模式',//创建分享选择会员返利模式
    exTextFiftyOne:'创建分享选择扩充下线模式',//创建分享选择扩充下线模式
    exTextFiftyTwo:'前往引荐计划',//前往引荐计划
    exTextFiftyThree:'去查看',//去查看
    exTextFiftyFour:'新增下线人数',//去查看
    exTextFiftyFive:'通过你分享的文件链接注册Feemoo账号，新用户将成为你的下线',//通过你分享的文件链接注册Feemoo账号，新用户将成为你的下线
    exTextFiftySix:'下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。',//下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。
  },
}
